//@ts-nocheck
import React from "react";
import { Document} from "@react-pdf/renderer";
import { MemberDetailsPage } from "./MemberDetails/MemberDetailsPage";
export const PdfDocument = ({ pdfData, translate, generationDateString }) => {
  return (
    <Document>
      {pdfData?.map((item) => (
        <MemberDetailsPage key={item.hash} item={item} translate={translate} generationDateString={generationDateString} />
      ))}
    </Document>
  );
};
